<template>
  <div id="Nov2023" class="202311 relative">
    <router-link :to="{ name: 'index' }" class="fixed right-0 top-0 w-24 p-3 z-50"><img src="~@/assets/images/202311/source01_logo.png" alt=""></router-link>
    <main class="main">
      <section class="banner z-50 w-full flex items-center">
        <div class="max-w-6xl mx-auto py-5">
          <div class="px-2"><img src="~@/assets/images/202311/source0_1.png" alt=""></div>
          <div><img src="~@/assets/images/202311/source0_2.png" alt=""></div>
        </div>
      </section>
      <section class="section1 z-40 w-full py-5 sm:py-10">
        <div class="max-w-6xl mx-auto py-6 px-4">
          <div class="mb-6 sm:mb-10 relative section1_1">
            <div class="relative"><img src="~@/assets/images/202311/source1_1.png" alt="">
              <div class="absolute bottom-0 w-1/5 people1" data-aos="fade-right" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100" data-aos-delay="400"><img src="~@/assets/images/202311/source1_2.png" alt=""></div>
            </div>
          </div>
          <div class="relative section1_2">
            <div><img src="~@/assets/images/202311/source1_3.png" alt=""></div>
            <div class="absolute bottom-0 w-1/4 people2" data-aos="fade-left" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100" data-aos-delay="400"><img src="~@/assets/images/202311/source1_4.png" alt=""></div>
          </div>
        </div>
      </section>
      <section class="section2 z-30 w-full py-5 sm:py-10">
        <div class="max-w-6xl mx-auto py-6 px-4">
          <a class="mb-8 flex justify-center items-center sm:px-8" href="https://store.liveabc.com/products/magazine/sale?tag=296" target="_blank">
            <div class="people3" data-aos="fade-left" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100" data-aos-delay="400"><img src="~@/assets/images/202311/source3_2.png" alt=""></div>
            <div class=""><img src="~@/assets/images/202311/source3_1.png" alt=""></div>
            <div class="people4" data-aos="fade-right" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100" data-aos-delay="400"><img src="~@/assets/images/202311/source3_3.png" alt=""></div>
          </a>
          <div class="flex flex-wrap mb-12">
            <router-link data-aos="fade-up" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100" data-aos-delay="400" :to="{ name: 'detail', params: { category: 'magazine', id: item.id } }" class="w-full sm:w-1/2 p-3" v-for="(item, index) in bookData1" :key="index">
              <img :src="item.img_url" alt="">
            </router-link>
          </div>
          <a class="book2 rounded-3xl pb-2 px-2 block" href="https://store.liveabc.com/products/magazine/sale?tag=296" target="_blank">
            <div class="w-3/5 sm:w-1/3 mx-auto"><img src="~@/assets/images/202311/source3_t.png" alt="" class="img1"></div>
            <div class="flex flex-wrap">
              <div class="w-1/3 sm:w-1/6 p-3" v-for="(item, index) in bookData2" :key="index" data-aos="fade-up" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100" data-aos-delay="400">
                <img :src="item.img_url" alt="">
              </div>
            </div>
          </a>
        </div>
      </section>
      <section class="section3 z-20 w-full py-5 sm:py-10">
        <div class="max-w-6xl mx-auto py-6 md:py-8 px-4">
          <a class="mb-8 flex items-center" href="https://store.liveabc.com/products/magazine/sale?tag=303" target="_blank">
            <div class=""><img src="~@/assets/images/202311/source04_1.png" alt=""></div>
            <div class=""><img src="~@/assets/images/202311/source04_2.png" alt="" class="imgT_1"></div>
          </a>
          <div class="flex flex-wrap">
            <router-link data-aos="fade-up" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100" data-aos-delay="400" :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="w-1/2 sm:w-1/3 p-4" v-for="(item, index) in bookData3" :key="index">
              <img :src="item.img_url" alt="">
            </router-link>
          </div>
        </div>
      </section>
      <section class="section4 z-0 w-full py-5 sm:py-10">
        <a class="max-w-6xl mx-auto pt-6 pb-12 md:pb-20 px-6 md:px-12 block" href="https://store.liveabc.com/products/magazine/sale?tag=302" target="_blank">
          <div class="rounded-3xl border-4 write-border px-3 md:px-6">
            <div class="w-1/2 mx-auto"><img src="~@/assets/images/202311/source05_1.png" alt="" class="imgT_2"></div>
            <div class="mb-8 flex">
              <div class="w-1/3"><img src="~@/assets/images/202311/source05_2.png" alt=""></div>
              <div class="w-1/3"><img src="~@/assets/images/202311/source05_3.png" alt=""></div>
              <div class="w-1/3"><img src="~@/assets/images/202311/source05_4.png" alt=""></div>
            </div>
            <div class=""><img src="~@/assets/images/202311/source05_5.png" alt=""></div>
            <div class="flex">
              <div class="w-1/2"><img src="~@/assets/images/202311/source05_6.png" alt=""></div>
              <div class="w-1/2 relative">
                <div class="absolute w-1/2 left-0 top-0"><img src="~@/assets/images/202311/source05_7.png" alt=""></div>
                <div class="absolute w-10/12 right-0 bottom-0"><img src="~@/assets/images/202311/source05_8.png" alt=""></div>
              </div>
            </div>
            <div class="w-2/5 sm:w-1/5 mx-auto"><img src="~@/assets/images/202311/source05_9.png" alt=""  class="imgT_3"></div>
          </div>
        </a>
      </section>
      <section class="section5 z-10 w-full">
        <div class="max-w-6xl mx-auto p-6 md:p-10"><img src="~@/assets/images/202311/source6.png" alt=""></div>
      </section>
    </main>
  </div>
</template>
<script>
import jump from 'jump.js'
export default {
  name: 'Nov2023',
  metaInfo () {
    return {
      title: '雙11就是要買爆!!',
      titleTemplate: null
    }
  },
  data () {
    return {
      isMenu: true,
      renderComponent: false,

      bookData1: [
        { id: 9104, img_url: require('@/assets/images/202311/source3_4.png') },
        { id: 9106, img_url: require('@/assets/images/202311/source3_5.png') },
        { id: 9100, img_url: require('@/assets/images/202311/source3_6.png') },
        { id: 9101, img_url: require('@/assets/images/202311/source3_7.png') },
        { id: 9102, img_url: require('@/assets/images/202311/source3_8.png') },
        { id: 9103, img_url: require('@/assets/images/202311/source3_9.png') }
      ],
      bookData2: [
        { id: 8993, img_url: require('@/assets/images/202311/source3_10.png') },
        { id: 8993, img_url: require('@/assets/images/202311/source3_11.png') },
        { id: 8993, img_url: require('@/assets/images/202311/source3_12.png') },
        { id: 8993, img_url: require('@/assets/images/202311/source3_13.png') },
        { id: 8993, img_url: require('@/assets/images/202311/source3_14.png') },
        { id: 8993, img_url: require('@/assets/images/202311/source3_15.png') }
      ],
      bookData3: [
        { id: 7796, img_url: require('@/assets/images/202311/source04_3.png') },
        { id: 8728, img_url: require('@/assets/images/202311/source04_4.png') },
        { id: 7822, img_url: require('@/assets/images/202311/source04_5.png') },
        { id: 7573, img_url: require('@/assets/images/202311/source04_6.png') },
        { id: 7707, img_url: require('@/assets/images/202311/source04_7.png') },
        { id: 7810, img_url: require('@/assets/images/202311/source04_8.png') }
      ]
    }
  },
  mounted () {
  },
  methods: {
    toTop (n) {
      jump(`${n}`, {
        duration: 500,
        offset: 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#Nov2023 {
  .banner {
    background-image: url('~@/assets/images/202311/source0_bg.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-color: #91220F;
    background-position: center;
  }
  .section1 {
    background-color: #011945;
    .people1 {
      left: -5%;
    }
    .people2 {
      right: -5%;
    }
  }
  .section2 {
    background-color: #91220F;
    .book2 {
      background-color: #360000;
    }
    .img1 {
      transform: translateY(-50%);
      // margin-top: -50%;
    }
  }
  .section3 {
    background-color: #360000;
    .imgT_1 {
      transform: translateX(-2%);
    }
  }
  .section4 {
    background-color: #360000;
    .write-border {
      border-color: #FFDE9B;
    }
    .imgT_2 {
      transform: translateY(-50%);
    }
    .imgT_3 {
      transform: translateY(60%);
    }
  }
  .section5 {
    background-color: #011945;
  }
}
</style>
